import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useModal } from '../../../contexts/Modal';
import { Button, Grid } from '@mui/material';

interface ReusableModalProps {
    actionButton: any;
    cancelButton: any;
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    p: 4,
    borderRadius: 2,
};


const DeleteModal: React.FC<ReusableModalProps> = ({ actionButton, cancelButton }) => {
    return (
        <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                Delete Confirmation
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                Are you sure you want to delete this user?
            </Typography>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={6}>
                    <Button variant="outlined" color="primary" fullWidth onClick={() => cancelButton()}>
                        Cancel
                    </Button>
                </Grid>
                <Grid item xs={6}>
                    <Button variant="outlined" color="error" fullWidth onClick={() => actionButton()}>
                        Delete User
                    </Button>
                </Grid>
            </Grid>
        </Box>

    );
}

const ConfirmModal: React.FC<ReusableModalProps> = ({ actionButton, cancelButton }) => {
    return (
        <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                Confirmation Required
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                Please confirm your action.
            </Typography>
        </Box>

    );
}

const AcceptModal: React.FC<ReusableModalProps> = ({ actionButton, cancelButton }) => {
    return (
        <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                Accept User
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                Are you sure you want to accept this user?
            </Typography>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={6}>
                    <Button variant="outlined" color="primary" fullWidth onClick={() => cancelButton()}>
                        Cancel
                    </Button>
                </Grid>
                <Grid item xs={6}>
                    <Button variant="outlined" color="success" fullWidth onClick={() => actionButton()}>
                        Accept User
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}

const ReusableModal: React.FC = () => {
    const { hideModal, modalStatus } = useModal();

    const modalMap: Record<string, React.ReactNode> = {
        delete: (
            <DeleteModal
                actionButton={modalStatus.validateAction}
                cancelButton={hideModal}
            />
        ),
        confirm: (
            <ConfirmModal
                actionButton={modalStatus.validateAction}
                cancelButton={hideModal}
            />
        ),
        accept: (
            <AcceptModal
                actionButton={modalStatus.validateAction}
                cancelButton={hideModal}
            />
        ),
    };

    if (!modalStatus.validateAction || !modalStatus.type) {
        return null; // No modal type is opened, return null
    }
    return (
        <Modal
            open={modalStatus.type !== null}
            onClose={hideModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {modalMap[modalStatus.type] ? (
                <Box sx={style}>
                    {modalMap[modalStatus.type]}
                </Box>
            ) : (
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Unknown Modal Type
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        The requested modal type does not exist.
                    </Typography>
                </Box>
            )}
        </Modal>
    );
}
export default ReusableModal;